import React from 'react'
import ModalLessonLandscape from '../../../../../../../View/internal/ModalLessonLandscape'

function CoursePreview({
  pages_landscape,
  onToggle,
  activeLessonId,
  lessonTitle,
  previewCurrentPage
}) {
  const userToken = localStorage.getItem('userToken')
  return (
    <>
      <ModalLessonLandscape
        modalVisible
        toggleModal={onToggle}
        userToken={userToken}
        previewData__pages_landscape={pages_landscape}
        lessonTitle={lessonTitle}
        activeLessonId={activeLessonId}
        previewCurrentPage={previewCurrentPage}
      />
    </>
  )
}

export default CoursePreview
